import axios, {AxiosResponse} from 'axios'
import {establishOwnerFromDomain} from '../../../../_metronic/helpers/custom/funcs/establishOwnerFromDomain'
import {User} from '../../../pages/users/core/_models'
import {AuthModel} from './_models'

const API_URL = `${process.env.REACT_APP_HTTP}${process.env.REACT_APP_URL}${process.env.REACT_APP_API_PATH}`

// Server should return AuthModel
export function login(username: string, password: string, lang: string) {
  return axios.post<AuthModel>(
    `${API_URL}/login_check`,
    {
      username,
      password,
    },
    {
      headers: {
        'Accept-Language': lang,

        owner: establishOwnerFromDomain(),
      },
    }
  )
}

// Server should return AuthModel
export function register(
  email: string,
  firstname: string,
  lastname: string,
  password: string,
  phoneNumber: string
  // password_confirmation: string
) {
  return axios.post(`${API_URL}/register`, {
    email,
    firstname,
    lastname,
    password,
    phoneNumber,
  })
}

// Server should return object => { result: boolean } (Is Email in DB)
export function requestPassword(email: string) {
  return axios.post<{result: boolean}>(`${API_URL}/forgot_password`, {
    email,
  })
}

export function getUser() {
  return axios.get<User>(`${API_URL}/profile`)
}

export function updateCurrentUser(user:Partial<User>): Promise<User | undefined> {
  return axios.put(`${API_URL}/profile`, user)
    .then((response: AxiosResponse<User>) => response.data)
}
export function updateCurrentUserPass(user:Partial<User>): Promise<User | undefined> {
  return axios.put(`${API_URL}/profile/change-password`, user)
    .then((response: AxiosResponse<User>) => response.data)
}
